module.exports = __webpack_public_path__ + "static/media/abhinav_design.e9dcb47e.jpeg";